import {
  HttpHeaders,
  HttpClient,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { environment } from 'src/environments/environment';
import { CptCode } from '../Models/cptcode.model';

@Injectable({
  providedIn: 'root',
})
export class CptcodeService {
  url = environment.Url2 + 'CptCodes';
  // url = environment.Url + 'CptCodes';
  // cptCode = 'https://binsera.co.uk/ICDcode/ICD_Code.json';
  header = new HttpHeaders({
    Authorization: 'token' + localStorage.getItem('token'),
  });
  private readonly HTTP_HEADERS = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*', // Note: "*" is not recommended. pass actual origin based on error message.
    }),
  };
  constructor(private http: HttpClient) {}

  // callAPI(): Observable<any[]> {
  //   return this.http.get<any[]>('https://binsera.co.uk/ICDcode/ICD_Code.json');
  // }

  // cptCodeApi(): Observable<any[]> {
  //   return this.http.get<any[]>('/assets/json/country-codes.json');
  // }
  registerCptCode(body) {
    return this.http
      .post<CptCode>(this.url, body)
      .pipe(catchError(this.handleError));
  }

  getCptCodes() {
    return this.http
      .get<CptCode[]>(this.url)
      .pipe(catchError(this.handleError));
  }
  // getCptCodeBinsera() {
  //   return this.http
  //     .get<CptCode[]>(this.cptCode)
  //     .pipe(catchError(this.handleError));
  // }
  getCptCodeById(id) {
    return this.http.get<CptCode>(this.url + '/' + id);
  }

  updateCptCode(id, body) {
    return this.http
      .put<CptCode>(this.url + '/' + id, body)
      .pipe(catchError(this.handleError));
  }

  deleteCptCode(id) {
    return this.http
      .delete<CptCode>(this.url + '/' + id)
      .pipe(catchError(this.handleError));
  }

  UploadJsonIcd10Data(data) {
    return this.http
      .post<CptCode[]>(this.url + '/uploadJsonCptCodes', data)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      if (error.status == 400) {
        console.log(error.error);
        return throwError(error.error);
      } else if (error.status == 401) {
        return throwError('invalid username or password');
      } else if (error.status == 0) {
        return throwError('network failure please try again later ');
      }
      return throwError(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    return throwError('Something bad happened; please try again later.');
  }
}
